(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/list-with-image"],{

/***/ "./src/assets/js/list-with-image.js":
/*!******************************************!*\
  !*** ./src/assets/js/list-with-image.js ***!
  \******************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var ListWithImage = /*#__PURE__*/function (_HTMLElement) {
  function ListWithImage() {
    var _this;
    _classCallCheck(this, ListWithImage);
    _this = _callSuper(this, ListWithImage);
    _this.svgContainers = document.querySelectorAll('.svg-container');
    _this.observer = null;
    _this.activeLine = null;
    _this.pathLength = 0;
    _this.animationStarted = false;
    _this.handleResize = _this.handleResize.bind(_this);
    window.addEventListener('resize', _this.handleResize);
    return _this;
  }
  _inherits(ListWithImage, _HTMLElement);
  return _createClass(ListWithImage, [{
    key: "initLineAnimation",
    value: function initLineAnimation() {
      this.setActiveLine();
      if (!this.activeLine) return;
      if (!this.animationStarted) {
        this.pathLength = this.activeLine.getTotalLength();
        this.activeLine.style.strokeDasharray = this.pathLength;
        this.activeLine.style.strokeDashoffset = this.pathLength;
      }
      this.setupObserver();
    }
  }, {
    key: "setActiveLine",
    value: function setActiveLine() {
      var isDesktop = window.innerWidth >= 993;
      var newActiveLine = null;
      this.svgContainers.forEach(function (container) {
        var line = container.querySelector(isDesktop ? '.animated-line__desktop' : '.animated-line__mobile');
        if (line) {
          newActiveLine = line;
        }
      });
      if (newActiveLine !== this.activeLine) {
        this.activeLine = newActiveLine;
        this.animationStarted = false;
        this.initLineAnimation();
      }
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      this.setActiveLine();
    }
  }, {
    key: "setupObserver",
    value: function setupObserver() {
      var _this2 = this;
      if (this.observer) return;
      this.observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (entry.target === _this2 && !_this2.animationStarted) {
              _this2.animationStarted = true;
              if (_this2.activeLine) {
                _this2.activeLine.style.strokeDashoffset = '0';
              }
            } else {
              entry.target.classList.add("animate");
              observer.unobserve(entry.target);
            }
          }
        });
      }, {
        threshold: 0.2
      });
      this.observer.observe(this);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initLineAnimation();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.cleanupObserver();
    }
  }, {
    key: "cleanupObserver",
    value: function cleanupObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('list-with-image')) {
  customElements.define('list-with-image', ListWithImage);
}

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/list-with-image.js"));
/******/ }
]);